(function (app, ng) {
    app.component('productionComponent',
        {
            templateUrl: 'App/Tools/MarketingTrackerNew/Dashboard/Components/Production/production.template.html',
            controller: 'productionController',
            bindings: {
                startDate: "<",
                endDate: "<"
            }
        })
        .controller('productionController',
            ["$interval", "marketingTrackerSalesTrackerDashboardApi", "$q",
                function ($interval, marketingTrackerSalesTrackerDashboardApi, $q) {
                    var $ctrl = this;

                    ng.extend($ctrl, {
                        ui: { loading: false },
                        productionData: {
                            currentProductionPercentage: 0,
                            currentProductionValue: 8000,
                            goalProductionValue: 10000,
                            LobHeaders: [
                                {
                                    Id: "00000000-0000-0000-0000-000000000000",
                                    LineOfBusinessName: "Life",
                                    Goal: 30000,
                                    IsActive: true
                                },
                                {
                                    Id: "00000000-0000-0000-0000-000000000000",
                                    LineOfBusinessName: "Annuities",
                                    Goal: 80000,
                                    IsActive: true
                                }
                            ],
                            ProductionRows: [
                                {
                                    Order: 0,
                                    Month: "Yearly Goal",
                                    LobProductions: [
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: 40000,
                                            LobName: null
                                        },
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: 40000,
                                            LobName: null
                                        }
                                    ]
                                },
                                {
                                    Order: 0,
                                    Month: "Monthly Goal",
                                    LobProductions: [
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: 40000,
                                            LobName: null
                                        },
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: -40000,
                                            LobName: null
                                        }
                                    ]
                                },
                                {
                                    Order: 0,
                                    Month: "January",
                                    LobProductions: [
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: 40000,
                                            LobName: null
                                        },
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: -40000,
                                            LobName: null
                                        }
                                    ]
                                },
                                {
                                    Order: 1,
                                    Month: "February",
                                    LobProductions: [
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: 40879,
                                            LobName: null
                                        },
                                        {
                                            LobId: "00000000-0000-0000-0000-000000000000",
                                            ProductionAmount: -34534,
                                            LobName: null
                                        }
                                    ]
                                }
                            ]
                        }
                    });

                    $ctrl.$onInit = function () {
                        $ctrl.currentProductionPercentage = Math.floor($ctrl.currentProductionValue / $ctrl.goalProductionValue * 100);                       

                        $ctrl.ui.loading = true;
                        const promises = [
                            marketingTrackerSalesTrackerDashboardApi.getProductionBreakdown($ctrl.startDate, $ctrl.endDate)
                        ];
                        $q.all(promises)
                            .then(function (responses) {                                
                                $ctrl.productionData = responses[0];
                                $ctrl.productionData.goalProductionValue = 0;
                                $ctrl.productionData.currentProductionValue = 0;
                                $ctrl.productionData.currentProductionPercentage = 0;
                                var goalRow = $ctrl.productionData.ProductionRows.find(function (row) { return row.Month === "Yearly Goal"; });
                                var yearRow = $ctrl.productionData.ProductionRows.find(function (row) { return row.Month === "Yearly Total"; });

                                for (i = 0; i < goalRow.LobProductions.length; i++) {
                                    $ctrl.productionData.goalProductionValue += goalRow.LobProductions[i].ProductionAmount;
                                    $ctrl.productionData.currentProductionValue += yearRow.LobProductions[i].ProductionAmount;
                                };
                            })
                            .finally(function () {
                                $ctrl.productionData.currentProductionPercentage = 100 * $ctrl.productionData.currentProductionValue / $ctrl.productionData.goalProductionValue
                                $ctrl.ui.loading = false;                             
                            });

                    };
                }
            ]);
})(window.app, window.angular); //jshint ignore:line